import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {MyNewsResultVo} from '../../common/shared/api/nicolas/vo/MyNewsVo.interface';
import type {Maybe} from '../../graphql/generated/types';
import {MyNewsTabType} from '../../graphql/generated/types';

/**
 * 내 소식 목록 조회
 *
 * Origin: pageNicolasApi.getMyNewsList
 * API: GET /api/v6/store/my_news
 */
export async function getStoreMyNews(
  {
    tab,
    refresh = false,
  }: {
    tab?: MyNewsTabType;
    refresh?: Maybe<boolean>;
  },
  options?: FetcherOptions
): Promise<MyNewsResultVo> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v6/store/my_news',
    {
      method: 'GET',
      params: {
        ...(tab && tab !== MyNewsTabType.All && {tab}),
        refresh: refresh ? 'Y' : 'N',
      },
    },
    options
  );
  return response.data;
}
